// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import GraphEditorController from "./graph_editor_controller"
application.register("graph-editor", GraphEditorController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import PlayController from "./play_controller"
application.register("play", PlayController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)
